const TRUSTPILOT_COLORS = {
  5: "#00b67a",
  4: "#73cf11",
  3: "#ffc61c",
  2: "#ff8622",
  1: "#ff3722",
} as const;

export const trustpilotColor = (rating: number): string => {
  if (rating >= 4.3) return TRUSTPILOT_COLORS[5];
  if (rating >= 3.8) return TRUSTPILOT_COLORS[4];
  if (rating >= 2.8) return TRUSTPILOT_COLORS[3];
  if (rating >= 1.8) return TRUSTPILOT_COLORS[2];

  return TRUSTPILOT_COLORS[1];
};
